import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgAiEdit(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.192 3.414A4 4 0 0 1 20.85 9.07l-2.047 2.047-.004.003-.004.005-9.068 9.067C8.371 21.55 6.64 22.014 5.33 22.158a10.052 10.052 0 0 1-2.165 0 6.074 6.074 0 0 1-.146-.02l-.042-.006-.013-.002-.005-.001h-.002l.164-.987-.165.987a1 1 0 0 1-.82-.82l.985-.167-.985.165-.001-.002-.001-.005-.002-.013-.007-.043-.018-.145a10.058 10.058 0 0 1-.002-2.165c.144-1.31.61-3.041 1.966-4.398l9.068-9.067h-.001l2.054-2.055Zm3.546 13.383a.276.276 0 0 1 .524 0l.35 1.065c.081.25.276.445.526.527l1.066.35a.275.275 0 0 1 0 .523l-1.066.35a.825.825 0 0 0-.527.526l-.35 1.066a.276.276 0 0 1-.523 0l-.35-1.067a.824.824 0 0 0-.526-.526l-1.066-.35a.275.275 0 0 1 0-.522l1.066-.35a.824.824 0 0 0 .527-.527l.35-1.065ZM5.485 15.95c-.91.91-1.273 2.13-1.391 3.202a8.036 8.036 0 0 0-.044 1.062c.298.007.662 0 1.061-.044 1.073-.118 2.293-.482 3.202-1.392l8.36-8.36-2.827-2.828-8.36 8.36Zm.043-13.519c.087-.308.524-.308.61 0l.297 1.048a2.544 2.544 0 0 0 1.752 1.753l1.05.296c.307.087.307.524 0 .61l-1.05.296a2.536 2.536 0 0 0-1.105.649 2.54 2.54 0 0 0-.647 1.104l-.296 1.05c-.087.307-.524.307-.61 0l-.297-1.05A2.537 2.537 0 0 0 3.48 6.434l-1.047-.296c-.308-.086-.308-.523 0-.61l1.047-.296a2.54 2.54 0 0 0 .994-.542l.76-1.21.295-1.049ZM19.436 4.83a2 2 0 0 0-2.83 0l-1.339 1.339 2.829 2.829 1.34-1.34a2 2 0 0 0 0-2.828Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgAiEdit)
